// Shared month-range presets for the internal cost dashboards (system + case).
// Both dashboards use this so a range means the same thing on each.

export const PERIODS = [
  { key: 'all', label: 'All-time' },
  { key: 'month', label: 'This month' },
  { key: 'last3', label: 'Last 3 months' },
  { key: 'last6', label: 'Last 6 months' },
  { key: 'last12', label: 'Last 12 months' },
  { key: 'ytd', label: 'Year to date' },
  { key: 'custom', label: 'Custom' },
];

const isoDay = (d) => d.toISOString().slice(0, 10);

// Returns { start, end } ISO date strings (end exclusive = tomorrow, so the
// current month is always included). `all` → { null, null } (server treats as
// all-time). `custom` passes the user's dates through.
export function periodRange(key, customStart, customEnd) {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setUTCDate(now.getUTCDate() + 1);
  const firstOfMonth = (monthsBack = 0) =>
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - monthsBack, 1));

  if (key === 'month') return { start: isoDay(firstOfMonth(0)), end: isoDay(tomorrow) };
  if (key === 'last3') return { start: isoDay(firstOfMonth(2)), end: isoDay(tomorrow) };
  if (key === 'last6') return { start: isoDay(firstOfMonth(5)), end: isoDay(tomorrow) };
  if (key === 'last12') return { start: isoDay(firstOfMonth(11)), end: isoDay(tomorrow) };
  if (key === 'ytd') return { start: isoDay(new Date(Date.UTC(now.getUTCFullYear(), 0, 1))), end: isoDay(tomorrow) };
  if (key === 'custom') return { start: customStart || null, end: customEnd || null };
  return { start: null, end: null }; // all-time
}
